export const FEEDBACK_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSdHpt8_LjIgVWBENZZvV4muRGU3iKk4Ied90qsLWzeRWCRMFw/viewform?usp=dialog';

export const buildUserGuideUrl = (locale?: string): string =>
  `https://guide.digibricks.net/${locale === 'vi' ? 'vi' : 'en'}`;

export const openExternalLink = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};
